import { render, staticRenderFns } from "./RevenuePlan.vue?vue&type=template&id=56be0a0c&"
import script from "./RevenuePlan.vue?vue&type=script&lang=js&"
export * from "./RevenuePlan.vue?vue&type=script&lang=js&"
import style0 from "./RevenuePlan.vue?vue&type=style&index=0&id=56be0a0c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports